/* eslint-disable
max-len,
no-mixed-spaces-and-tabs,
react/jsx-indent,
react/jsx-first-prop-new-line,
*/

import React, { PureComponent, PropTypes } from 'react';
import styles from './styles.scss';

export class Hand extends PureComponent {
  render() {
    return (
      <div className={this.props.className}>
        <svg version="1.1"
          id="Hand"
          xmlns="http://www.w3.org/2000/svg"
          x="0px"
          y="0px"
          viewBox="0 0 136.7 285.1"
          className={styles.st4}
          xmlSpace="preserve"
          preserveAspectRatio="xMaxYMax slice"
        >
        <g>
          <path className={styles.st0}
            d="M42.3,203.2c1.7,1.7,2.9,4,3.5,6.4l2.8,15.3l-3.5,0c-1.6,0-2.9,1.2-3.1,2.7h80.5c-0.2-1.6-1.5-2.9-3.2-2.9
            l-1.2,0l0,0V211c0-2.4,0.8-4.7,2.3-6.6l13.8-17.2c0.9-1.1,2.6-9,2.6-10.5l-1.2-67.7c0-4-3.2-7.2-7.2-7.2h-7.2v-0.1h-2.6
            c-1.4,0-2.6-1-3-2.3l-0.9-9.3l0-1.1c-0.1-3.4-3-6.1-6.4-6.1l-13.6,0.3V83l-4,0.1c0,0,0,0-0.1,0L87.8,82c-1.3-1.1-2.2-2.7-2.1-4.5
            l0.3-6.5c0-5-3.6-7.8-8.5-7.4l-14.5,0.1l-1.6-0.8c-0.3-0.4-0.5-0.8-0.5-1.3l0-45.3C60.8,9,54.9,3,47.5,3h-0.3
            c-7.6,0-13.8,6.1-13.8,13.7c0,25.1,0,79.2,0,93.5c0,0.1,0,0.2,0,0.2L25.6,146c-0.3,0.8-0.4,1.6-0.4,2.5v34.2c0,1.7,0.6,3.4,1.6,4.8
            L42.3,203.2z M33.4,110.1C33.4,104.4,33.4,108.7,33.4,110.1L33.4,110.1z"
          />
          <g>
            <path className={styles.st1}
              d="M36.8,224.8l68.9-3.1V208c0-2.4,0.8-4.7,2.3-6.6l13.8-17.2c0.9-1.1,2.6-9,2.6-10.5l-1.2-67.7
              c0-4-3.2-7.2-7.2-7.2h-9.4c-2.1,0-3.9-1.7-4-3.8l-0.3-9.1c-0.1-3.4-3-6.1-6.4-6.1l-17,0.3c-3.2,0.1-5.7-2.6-5.6-5.7l0.3-6.5
              c0-5-3.6-7.8-8.5-7.4l-14.5,0.1c-1.1,0-2.1-0.9-2.1-2.1l0-45.3C48.5,6,42.5,0,35.2,0h-0.3c-7.6,0-13.8,6.1-13.8,13.7
              c0,30.2,0,102.1,0,96.7c0-11.8,0.1-3.2,0-3L13.3,143c-0.3,0.8-0.4,1.6-0.4,2.5v34.2c0,1.7,0.6,3.4,1.6,4.8L30,200.2
              c1.7,1.8,2.9,4,3.5,6.4L36.8,224.8z"
            />
            <path className={styles.st2} d="M53.1,95.8h-2.3c-1.3,0-2.3-1-2.3-2.3V59.6l2.1,1h4.9v32.9C55.4,94.8,54.4,95.8,53.1,95.8z" />
            <path className={styles.st2} d="M80.3,115.2h-2.9c-1.1,0-2-0.9-2-2V79l2.9,1.1l4.1-0.1v33.2C82.4,114.3,81.5,115.2,80.3,115.2z" />
            <path className={styles.st2}
              d="M107,133.9h-3.1c-1,0-1.9-0.8-1.9-1.9V90.6l0.4-3.6l0.9,9.3c0.3,1.4,1.5,2.3,3,2.3h2.6V132
              C108.9,133,108,133.9,107,133.9z"
            />
            <path className={styles.st3} d="M113,249.4l-90,0.1c-4.9,0.1-8.8,4.1-8.8,9l-1.3,26.6h111.5l-2.4-28.3C121.8,251.9,117.9,249.3,113,249.4z" />
            <path className={styles.st3} d="M29.6,251.9l-0.1-27.8c0-1.2,1-2.2,2.2-2.2l76.1-0.2c1.2,0,2.2,1,2.2,2.2l0.1,27.8L29.6,251.9z" />

              <rect x="66.7" y="205.8" transform="matrix(2.587154e-03 1 -1 2.587154e-03 315.7992 175.6159)" className={styles.st0} width="6.3" height="80.5" />
          </g>
        </g>
        </svg>
      </div>
    );
  }
}

Hand.propTypes = {
  className: PropTypes.string,
};

export default Hand;



// WEBPACK FOOTER //
// ./src/components/sign_up/sign_up_carousel/shared/hand/index.jsx